import React from 'react';
import { useToast } from './ToastProvider';
import { Link } from 'react-router-dom';
import '../../css/theme.css';
import '../../css/components/Toast.css';

const ToastDemo = () => {
  const toast = useToast();

  return (
    <div className="toast-demo-container" style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto' }}>
      <header style={{ marginBottom: '40px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px', background: 'linear-gradient(135deg, var(--primary), var(--secondary))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          New Messaging UI System
        </h1>
        <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0 auto', color: 'var(--text-secondary)' }}>
          We've improved our messaging UI with a modern toast notification system that provides contextual feedback
        </p>
      </header>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
        <div className="glass-card" style={{ flex: '1 1 400px', maxWidth: '600px' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', color: 'var(--primary)' }}>
            Toast Notification Demo
          </h2>
          <p style={{ marginBottom: '24px', lineHeight: '1.6' }}>
            Our new toast notification system replaces traditional alerts with beautiful, informative notifications that enhance the user experience.
            Try out the different types of notifications below:
          </p>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <button 
              onClick={() => toast.info('This is an information message', 5000)}
              className="btn btn-primary"
              style={{ background: 'var(--info)', border: 'none' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              Info Toast
            </button>
            
            <button 
              onClick={() => toast.success('Your action was completed successfully!', 5000)}
              className="btn btn-primary"
              style={{ background: 'var(--success)', border: 'none' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              Success Toast
            </button>
            
            <button 
              onClick={() => toast.warning('Please be careful with this action', 5000)}
              className="btn btn-primary"
              style={{ background: 'var(--warning)', border: 'none' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
              Warning Toast
            </button>
            
            <button 
              onClick={() => toast.error('An error occurred while processing your request', 5000)}
              className="btn btn-primary"
              style={{ background: 'var(--error)', border: 'none' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
              Error Toast
            </button>
          </div>
        </div>

        <div className="glass-card" style={{ flex: '1 1 400px', maxWidth: '600px' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', color: 'var(--primary)' }}>
            Key Features
          </h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {[
              'Modern glass morphism design with subtle blur effects',
              'Contextual colors for different message types',
              'Animated entrance and exit transitions',
              'Auto-dismissal with configurable duration',
              'Manual close option',
              'Responsive design for all screen sizes',
              'Stacking support for multiple notifications',
              'Accessible with proper ARIA attributes'
            ].map((feature, index) => (
              <li key={index} style={{ padding: '12px 0', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '12px', flexShrink: 0 }}>
                  <polyline points="9 11 12 14 22 4"></polyline>
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                </svg>
                {feature}
              </li>
            ))}
          </ul>
          
          <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center' }}>
            <Link to="/pricing" className="btn btn-primary" style={{ textDecoration: 'none' }}>
              See it in action on Pricing Page
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToastDemo;